import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { MassEmailArgs } from '../_models/mass-email-args';
import { APIOperationResult } from '../_models/apioperation-result';

@Injectable({
  providedIn: 'root'
})
export class MassEmailService {

  constructor(public httpClient: HttpClient) { }

  public sendEmail(args: MassEmailArgs) : Promise<APIOperationResult> {
    var prom = new Promise<APIOperationResult>((resolve, reject) => {
      var url = "api/MassEmail/Send";

      this.httpClient.post(url, args).subscribe((result: any) => {
        resolve(result);
      },
      (err) => {
        reject();
      });

    });

    return prom;
  }
}
